import { atom, selector } from 'recoil';
import { GetTeamsRequest } from 'api';
import { upperCaseFirstLetter } from 'tools';

export const manageTeamPageSizeState = atom<number>({
  key: 'manageTeamPageSize',
  default: 10,
});

export const manageTeamPageNumberState = atom<number>({
  key: 'manageTeamPageNumber',
  default: 1,
});

export const manageTeamSearchState = atom<string>({
  key: 'manageTeamSearch',
  default: '',
});

export const manageTeamOrganisationFilterState = atom<string>({
  key: 'manageTeamOrganisationFilter',
  default: '',
});

export const manageTeamSortByDescendingFilterState = atom<boolean | undefined>({
  key: 'manageTeamSortByDescendingFilterState',
  default: undefined,
});

export const manageTeamSortByColumnFilterState = atom<string>({
  key: 'manageTeamSortByColumnFilterState',
  default: '',
});

export const manageTeamsRequestState = selector<GetTeamsRequest>({
  key: 'manageTeamSearchRequest',
  get: ({ get }) => {
    const sortByDesc = get(manageTeamSortByDescendingFilterState);
    let sortByColumn = get(manageTeamSortByColumnFilterState);

    if (sortByColumn) {
      sortByColumn = sortByColumn.startsWith('team')
        ? sortByColumn
        : 'team' + upperCaseFirstLetter(sortByColumn);
    }

    return {
      nameOrEmailSearchText: get(manageTeamSearchState) ?? null,
      organisationName: get(manageTeamOrganisationFilterState),
      pageNumber: get(manageTeamPageNumberState),
      pageSize: get(manageTeamPageSizeState),
      ...(sortByColumn && {
        sortByValue: sortByColumn,
        sortBy: sortByDesc ? 'Descending' : 'Ascending',
      }),
    };
  },
});
